import React from 'react';
import useStyles from '../styles';
import { useStore } from 'src/stores';
import { observer } from 'mobx-react-lite';
import RippleEffect from 'src/components/general/RippleEffect';
export const OccupancyCell = observer(_ref => {
  var _params$row;
  let params = _ref.params,
    setMmodalTempData = _ref.setMmodalTempData;
  const store = useStore();
  const classes = useStyles();
  return /*#__PURE__*/React.createElement("div", null, params.row.vacant && /*#__PURE__*/React.createElement("div", {
    onClick: () => {
      if (store.company.companyFeatureStore.disableUnitOccupancyChange) return;
      setMmodalTempData({
        unitname: params.row.Unitname,
        occupancy: params.row.occupancy,
        unitData: params.row.unitData
      });
      store.residencies.showOccupancyUpdateModal(true);
      setTimeout(() => {
        document.getElementById('DGOccupancyUpdateModal').click();
      }, 0);
    }
  }, /*#__PURE__*/React.createElement(RippleEffect, {
    className: "".concat(classes.cellContent, " cellContent")
  }, params.row.occupancy)), !params.row.vacant && /*#__PURE__*/React.createElement(RippleEffect, {
    className: "".concat((_params$row = params.row) !== null && _params$row !== void 0 && _params$row.isEnrolmentScheduled ? classes.disabledCellText : classes.cellContent, " cellContent")
  }, params.row.occupancy));
});